import { FC } from 'react'
import { Apartment, Freelance, House, Industrial, Office, Shop } from '../assets'
import SimulationButton from '../components/simulation-button/SimulationButton'
import { BuildingType } from '../types'
import { nextSimulationStep } from 'store/simulation/actions/switchSimulationStep'
import { updateSimulationInput } from 'store/simulation/actions/updateSimulationInput'
import { useDispatch, useSelector } from 'react-redux'
import { Store } from 'store/types'
import NavigationButtons from '../components/navigation-buttons/NavigationButtons'
import { SimulationInputKeys } from 'store/simulation/types'
import { trackEvent } from 'utils/eventTracking'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import styles from '../components/simulation-button/SimulationButton.module.scss'
import stepStyles from './Steps.module.scss'

export const BuildingTypeStep: FC = () => {
  // REDUX STORE
  const { inputs } = useSelector((state: Store) => state.simulation)
  const dispatch = useDispatch()

  // i18n
  const { t } = useTranslation('simulation')

  /**
   * Handles the simulation button click
   *
   * @param buildingType
   */
  const handleSimulationButtonClick = (buildingType: BuildingType) => {
    // Set hasVat in simulation store
    dispatch(updateSimulationInput({ key: SimulationInputKeys.BUILDING_TYPE, value: buildingType }))

    // Track 'Simulation Started' event @Semetis
    trackEvent('simulation_started', {
      housing_type: buildingType,
      step: 'building-type'
    })

    // Go to next step
    dispatch(nextSimulationStep())
  }

  return (
    <div>
      <div className="is-flex-column is-flex-centered">
        <h2 className={classNames(stepStyles.title, 'margin-top-none', 'margin-bottom-l')}>
          {inputs.hasVat ? t('companyTypeTitle', 'Mijn bedrijf is een...') : t('houseTypeTitle', 'Ik woon in een...')}
        </h2>
      </div>

      {inputs.hasVat ? (
        <div className={classNames(styles['simulation-buttons'], styles['is-4'])}>
          <SimulationButton
            title={t('freelance', 'Zelfstandige')}
            icon={<Freelance />}
            onClick={() => handleSimulationButtonClick(BuildingType.Soho)}
            highlighted={inputs.buildingType === BuildingType.Soho}
          />

          <SimulationButton
            title={t('office', 'Kantoor')}
            icon={<Office />}
            onClick={() => handleSimulationButtonClick(BuildingType.Office)}
            highlighted={inputs.buildingType === BuildingType.Office}
          />

          <SimulationButton
            title={t('shop', 'Winkel')}
            icon={<Shop />}
            onClick={() => handleSimulationButtonClick(BuildingType.Shop)}
            highlighted={inputs.buildingType === BuildingType.Shop}
          />

          <SimulationButton
            title={t('industrial', 'Industrie')}
            icon={<Industrial />}
            onClick={() => handleSimulationButtonClick(BuildingType.Industry)}
            highlighted={inputs.buildingType === BuildingType.Industry}
          />
        </div>
      ) : (
        <div className={classNames(styles['simulation-buttons'], styles['is-2'])}>
          <SimulationButton
            title={t('house', 'Huis')}
            icon={<House />}
            onClick={() => handleSimulationButtonClick(BuildingType.House)}
            highlighted={inputs.buildingType === BuildingType.House}
          />

          <SimulationButton
            title={t('apartment', 'Appartement')}
            icon={<Apartment />}
            onClick={() => handleSimulationButtonClick(BuildingType.Apartment)}
            highlighted={inputs.buildingType === BuildingType.Apartment}
          />
        </div>
      )}

      <NavigationButtons nextDisabled={inputs.buildingType === null} onNextClick={() => handleSimulationButtonClick(inputs.buildingType)} />
    </div>
  )
}
